module.exports = __webpack_public_path__ + "img/77.b209fce9.png";